let __blogBound = false;
let __blogLoading = false;
let __blogController = null;

function withSectionsParam(url, sectionId) {
  try {
    const u = new URL(url, window.location.origin);
    const sections = u.searchParams.get('sections');

    if (!sections) {
      u.searchParams.set('sections', sectionId);
    } else if (!sections.split(',').includes(sectionId)) {
      u.searchParams.set('sections', sections + ',' + sectionId);
    }

    return u.toString();
  } catch (e) {
    const sep = url.indexOf('?') > -1 ? '&' : '?';
    return url + sep + 'sections=' + encodeURIComponent(sectionId);
  }
}

function getBlogSection(scope) {
  return (scope || document).querySelector(
    '[id^="team-grid-"][data-section-id][data-blog-handle]'
  );
}

function getBlogContainer(section) {
  return section ? section.querySelector('.container') : null;
}

function setLoading(section, isLoading) {
  if (!section) return;
  section.classList.toggle('is-loading', !!isLoading);
}

function setActiveLink(section, href) {
  if (!section) return;

  const links = section.querySelectorAll('[data-filter-link]');
  if (!links.length) return;

  const currentUrl = new URL(href, window.location.origin);
  const currentPath = currentUrl.pathname.replace(/\/+$/, '') || '/';

  links.forEach((link) => {
    const linkUrl = new URL(link.href, window.location.origin);
    const linkPath = linkUrl.pathname.replace(/\/+$/, '') || '/';
    const isActive = linkPath === currentPath;

    link.classList.toggle('is-active', isActive);
  });
}

function swapSectionHTML(rawHTML, sectionId) {
  const temp = document.createElement('div');
  temp.innerHTML = rawHTML;

  const incomingSection =
    temp.querySelector('#team-grid-' + sectionId) ||
    temp.querySelector('[id^="team-grid-"][data-section-id][data-blog-handle]');

  const currentSection = getBlogSection();

  if (!incomingSection || !currentSection) return false;

  const incomingContainer = getBlogContainer(incomingSection);
  const currentContainer = getBlogContainer(currentSection);

  if (!incomingContainer || !currentContainer) return false;

  currentContainer.innerHTML = incomingContainer.innerHTML;

  currentSection.dispatchEvent(new Event('page:load', { bubbles: true }));

  return true;
}

function fetchAndSwap(url, options = {}) {
  const section = getBlogSection();
  if (!section) return Promise.resolve(false);

  if (__blogLoading && !options.fromPopstate) {
    return Promise.resolve(false);
  }

  const sectionId = section.getAttribute('data-section-id');
  if (!sectionId) return Promise.resolve(false);

  if (__blogController) {
    __blogController.abort();
  }

  __blogController = new AbortController();
  __blogLoading = true;
  setLoading(section, true);

  const apiURL = withSectionsParam(url, sectionId);

  return fetch(apiURL, {
    signal: __blogController.signal,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json'
    }
  })
    .then((res) => {
      const ct = res.headers.get('Content-Type') || '';

      if (ct.includes('application/json')) {
        return res.json();
      }

      return res.text().then((html) => ({ __html: html }));
    })
    .then((payload) => {
      let swapped = false;

      if (payload && typeof payload === 'object' && !payload.__html) {
        const html = payload[sectionId];
        if (html) {
          swapped = swapSectionHTML(html, sectionId);
        }
      } else if (payload && payload.__html) {
        swapped = swapSectionHTML(payload.__html, sectionId);
      }

      const updatedSection = getBlogSection();
      setLoading(updatedSection, false);
      __blogLoading = false;
      __blogController = null;

      if (swapped) {
        setActiveLink(updatedSection, url);
      }

      return swapped;
    })
    .catch((error) => {
      if (error && error.name !== 'AbortError') {
        console.error('Blog filter AJAX error:', error);
      }

      const updatedSection = getBlogSection();
      setLoading(updatedSection, false);
      __blogLoading = false;
      __blogController = null;

      return false;
    });
}

export function initBlogFilters(scope) {
  const section = getBlogSection(scope);
  if (!section) return;

  if (!__blogBound) {
    __blogBound = true;

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const section = getBlogSection();
      if (!section) return;

      const isInsideThisSection = link.closest('#' + section.id) !== null;
      if (!isInsideThisSection) return;

      const isFilter = link.matches('[data-filter-link]');
      const isPagination = link.closest('.pagination') !== null;

      if (!isFilter && !isPagination) return;

      const href = link.getAttribute('href');
      if (!href) return;

      e.preventDefault();

      fetchAndSwap(href).then((swapped) => {
        if (swapped) {
          history.pushState({}, '', href);
        }
      });
    });

    window.addEventListener('popstate', () => {
      fetchAndSwap(window.location.href, { fromPopstate: true });
    });
  }

  setActiveLink(section, window.location.href);
}

export const initTeamFilters = initBlogFilters;